import {
  BANNER,
  BANNERADD,
  BANNERDELETE,
  CATALOGPRODUCTCLONE,
  CATALOGPRODUCTCLONELIST,
  CREATECATALOGDELETE,
  CREATECATALOGDRAFT,
  CREATECATALOGGET,
  CREATECATALOGPRODUCT,
  CREATECATALOGUPDATE,
  DASHBOARD,
  DELETECATALOGIMAGE,
  GET_REFUNDS_SUCCESS,
  ONADMINDETAIL,
  ONADMINLOGIN,
  ONALLADMIN,
  ONALLORDERS,
  ONALLPRODUCTS,
  ONALLROLE,
  ONCATALOGLIST,
  ONCATALOGSUBMIT,
  ONCATALOGVIEW,
  ONCATEGORIES,
  ONCATEGORIESADD,
  ONCATEGORIESDELETE,
  ONCATEGORIESEDIT,
  ONCATEGORIESLIST,
  ONCREATEADMIN,
  ONCREATEROLE,
  ONCREATESHIPMENT,
  ONCREATESHIPMENTLABEL,
  ONDELETEADMIN,
  ONDELETEROLE,
  ONEDITADMIN,
  ONEDITROLE,
  ONLIVECATALOGPRODUCT,
  ONOFFERS,
  ONOFFERSADD,
  ONOFFERSDELETE,
  ONOFFERSEDIT,
  ONPRODUCTADD,
  ONPRODUCTDELET,
  ONPRODUCTEDIT,
  ONPRODUCTS,
  ONPRODUCTVIEW,
  ONSENDNOTIFICATION,
  ONSIZEGUIDE,
  ONSIZEGUIDEADD,
  ONSIZEGUIDEDELETE,
  ONSIZEGUIDEEDIT,
  ONUSERS,
  REFUND_PROCESSING,
  REFUND_SUCCESS,
  UPLOADCATALOGIMAGE,
} from "./type";

const initialState = {
  getOnUsers: [],
  getOnProducts: [],
  getOnAllProducts: [],
  getOnProductView: [],
  getOnProductEdit: [],
  getOnProductAdd: [],
  getOnProductDelete: [],
  getOnCategories: [],
  getOnCategoriesList: [],
  getOnCategoriesDelete: [],
  getOnCategoriesAdd: [],
  getOnCategoriesEdit: [],
  getOnSizeGuide: [],
  getOnSizeGuideAdd: [],
  getOnSizeGuideEdit: [],
  getOnSizeGuideDelete: [],
  getOffers: [],
  getOffersAdd: [],
  getOffersEdit: [],
  getOffersDelete: [],
  getAllOrders: [],
  getCreateRole: [],
  getAllRole: [],
  getEditRole: [],
  getDeleteRole: [],
  getAdminLogin: [],
  getAllAdmin: [],
  getDeleteAdmin: [],
  getEditAdmin: [],
  getCreateAdmin: [],
  getSendNotification: [],
  getDashboardData: [],
  getBanner: [],
  getBannerAdd: [],
  getBannerDelete: [],
};

const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case ONUSERS:
      return { ...state, getOnUsers: action.payload };
    case ONPRODUCTS:
      return { ...state, getOnProducts: action.payload };
    case ONALLPRODUCTS:
      return { ...state, getOnAllProducts: action.payload };
    case ONPRODUCTVIEW:
      return { ...state, getOnProductView: action.payload };
    case ONPRODUCTEDIT:
      return { ...state, getOnProductEdit: action.payload };
    case ONPRODUCTADD:
      return { ...state, getOnProductAdd: action.payload };
    case ONPRODUCTDELET:
      return { ...state, getOnProductDelete: action.payload };
    case ONCATEGORIES:
      return { ...state, getOnCategories: action.payload };
    case ONCATEGORIESLIST:
      return { ...state, getOnCategoriesList: action.payload };
    case ONCATEGORIESDELETE:
      return { ...state, getOnCategoriesDelete: action.payload };
    case ONCATEGORIESADD:
      return { ...state, getOnCategoriesAdd: action.payload };
    case ONCATEGORIESEDIT:
      return { ...state, getOnCategoriesEdit: action.payload };
    case ONSIZEGUIDE:
      return { ...state, getOnSizeGuide: action.payload };
    case ONSIZEGUIDEADD:
      return { ...state, getOnSizeGuideAdd: action.payload };
    case ONSIZEGUIDEEDIT:
      return { ...state, getOnSizeGuideEdit: action.payload };
    case ONSIZEGUIDEDELETE:
      return { ...state, getOnSizeGuideDelete: action.payload };
    case ONOFFERS:
      return { ...state, getOffers: action.payload };
    case ONOFFERSADD:
      return { ...state, getOffersAdd: action.payload };
    case ONOFFERSEDIT:
      return { ...state, getOffersEdit: action.payload };
    case ONOFFERSDELETE:
      return { ...state, getOffersDelete: action.payload };
    case ONALLORDERS:
      return { ...state, getAllOrders: action.payload };
    case ONCREATEROLE:
      return { ...state, getCreateRole: action.payload };
    case ONCREATESHIPMENT:
      return { ...state, getCreateShipment: action.payload };
    case ONCREATESHIPMENTLABEL:
      return { ...state, getCreateShipmentLabel: action.payload };
    case ONALLROLE:
      return { ...state, getAllRole: action.payload };
    case ONEDITROLE:
      return { ...state, getEditRole: action.payload };
    case ONDELETEROLE:
      return { ...state, getDeleteRole: action.payload };
    case ONADMINLOGIN:
      return { ...state, getAdminLogin: action.payload };
    case ONEDITADMIN:
      return { ...state, getEditAdmin: action.payload };
    case ONDELETEADMIN:
      return { ...state, getDeleteAdmin: action.payload };
    case ONALLADMIN:
      return { ...state, getAllAdmin: action.payload };
    case ONCREATEADMIN:
      return { ...state, getCreateAdmin: action.payload };
    case ONADMINDETAIL:
      return { ...state, getAdminDetail: action.payload };
    case ONSENDNOTIFICATION:
      return { ...state, getSendNotification: action.payload };
    case DASHBOARD:
      return { ...state, getDashboardData: action.payload };
    case BANNER:
      return { ...state, getBanner: action.payload };
    case BANNERADD:
      return { ...state, getBannerAdd: action.payload };
    case BANNERDELETE:
      return { ...state, getBannerDelete: action.payload };
    case CREATECATALOGDRAFT:
      return { ...state, getCreateCatalogDraft: action.payload };
    case CREATECATALOGGET:
      return { ...state, getCreateCatalogGet: action.payload };
    case CREATECATALOGUPDATE:
      return { ...state, getCreateCatalogUpdate: action.payload };
    case CREATECATALOGDELETE:
      return { ...state, getCreateCatalogDelete: action.payload };
    case CREATECATALOGPRODUCT:
      return { ...state, getCreateCatalogProduct: action.payload };
    case CATALOGPRODUCTCLONE:
      return { ...state, getCatalogProductClone: action.payload };
    case CATALOGPRODUCTCLONELIST:
      return { ...state, getCatalogProductCloneList: action.payload };
    case UPLOADCATALOGIMAGE:
      return { ...state, getUploadCatalogImage: action.payload };
    case DELETECATALOGIMAGE:
      return { ...state, getDeleteCatalogImage: action.payload };
    case ONCATALOGSUBMIT:
      return { ...state, getOnCatalogSubmit: action.payload };
    case ONCATALOGLIST:
      return { ...state, getOnCatalogList: action.payload };
    case ONCATALOGVIEW:
      return { ...state, getOnCatalogView: action.payload };
    case ONLIVECATALOGPRODUCT:
      return { ...state, getOnLiveCatalogProduct: action.payload };
    case GET_REFUNDS_SUCCESS:
      return { ...state, refunds: action.payload };

    case REFUND_PROCESSING:
      return { ...state, processingId: action.payload };

    case REFUND_SUCCESS:
      return {
        ...state,
        refunds: state.refunds.filter((item) => item._id !== action.payload),
        processingId: null,
      };
    default:
      return state;
  }
};

export default homeReducer;
